import { LoadablePaint } from '@confluence/loadable';

export const WorkflowsLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-WorkflowAccessWrapper" */ '../src/WorkflowAccess'))
			.WorkflowAccessWrapper,
});
